import React from 'react'
import TextInput from '../inputs/TextInput'

interface LinkPropertyFieldProps {
	value: any
	onChange: (value: any) => void
	placeholder?: string
}

export default function LinkPropertyField({ value, onChange, placeholder }: LinkPropertyFieldProps) {
	// Handle both string and object formats
	const linkValue = typeof value === 'string' ? value : value?.value || ''
	
	return (
		<div className="space-y-2">
			<TextInput 
				type="url" 
				value={linkValue} 
				onChange={(v) => onChange({ value: v })} 
				placeholder={placeholder || 'https://...'} 
			/>
		</div>
	)
}


